import axios from "axios";
import { useEffect, useState } from "react";

const useItems = (endPoint, params = {}, language) => {
	const lang = language === 'fr-FR' ? '/fr' : '';
	let baseUrl = window.origin;
	let reqUrl = `${baseUrl}${lang}/wp-json/bmo/v1/${endPoint}`;
	const [response, setResponse] = useState([]);
	const [pagesArray, setPagesArray] = useState([]);
	
	useEffect(() => {
		const getResponse = async () => {
			try {
				const { data } = await axios.get(reqUrl, {params});
				
				if (endPoint === 'milestones' && !data.length) {
					setResponse([]);
				}

				if (endPoint === 'milestones' && data.length) {
					setResponse([...data]);
				}
				
				if (endPoint === 'collection' && !data.item_count) {
					setResponse([]);
					setPagesArray([]);
				}

				if (endPoint === 'collection' && data.item_count) {
					const createPagesArray = () => {
						const ITEMS_PER_PAGE = 12;
						const totalPages = Math.ceil(data.item_count/ITEMS_PER_PAGE);
						const pagesArr = [];
						for (let i = 1; i <= totalPages; i++) {
							pagesArr.push(i);
						}
						
						return pagesArr;
					};

					const formatData = (array) => {
						const arrayCopy = [...array];
						const newArray = [];
						arrayCopy.forEach(item => {
							const newGallery = item.gallery.filter(image => image.id !== item.image.id);
							item.gallery = newGallery;
							newArray.push(item);
						});

						return newArray;
					}
					
					const pagesArr = createPagesArray();
					const dataArray = formatData(data.items);
					setResponse(dataArray);
					setPagesArray(pagesArr);
				}

			} catch (error) {
				throw new Error('Api request failed', { cause: error });
			}
		};
		getResponse();
	}, [params, language]);

	return [response, setResponse, pagesArray];
};

export default useItems;
